<template>
  <div class="richtext-container">
   <slot name="content"></slot>
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
    }
  },
  beforeDestroy () {
  }
}
</script>
<style lang="less" scoped>
.richtext-container{
    height: 100%;
}
</style>
